<template>
  <div v-if="dataNotNull" key="1" class="expiredDiv" style="width: 100%; height: 100%">
    <div class="container1" style="margin:15px 0 0 20px; height: 100%;"></div>
  </div>
  <div v-else key="2" style="width: 100%; height: 100%;">
    <div class="title_expired">{{ title }}
    </div>
    <div class="zero_expired">No Data !</div>
  </div>
</template>

<script>

import axios from 'axios'
import echarts from 'echarts'

export default {
  name: "expired",
  props: ['project_id'],
  data() {
    return {
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "expired",
      dataNotNull: true,
      title: 'Work Pass'
    }
  },
  methods: {
    init() {
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    analysisResult(result) {
      var legends = []
      var series = []
      for (var i in result) {
        legends.push(result[i].nation_type)
        series.push({name: result[i].nation_type, value: result[i].nation_num})
      }
      return {legends: legends, series: series}
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    let that = this
    this.myChart = echarts.init(document.querySelector('.expiredDiv .container1'))
    this.myChart.setOption({
      title: {
        text: that.title,
        textStyle: {
          color: '#FFF',
          fontSize: 16
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        textStyle: {
          fontSize: '16'
        }
      },
      xAxis: {
        type: 'category',
        inverse: true,
        data: ['WP', 'SP', 'EP'],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#6CF'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#FFF',
            fontSize: 16
          }
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        // axisLabel: {
        //   formatter: '{value}'
        // },
        splitLine: {
          show: false
        }
      },
      series: [
        {
          type: 'bar',
          barWidth: '40%',
          data: [5, 6, 7],
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return that.color[params.dataIndex]
              },
            }
          },
        }
      ]
    })

    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });

    let postData = {
      project_id: this.project_id,
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjNationality", postData).then(resp => {    //生产
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var result = resp.data.result;
        var data = this.analysisResult(result);
        if (this.dataNotNull) {
          this.myChart.setOption({
            // legend: {
            //   data: data.legends,
            //   itemGap: 6,
            // },
            // series: [{
            //   data: data.series
            // }]
          })
        }
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })
    // this.init()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.title_expired
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.zero_expired
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/manpower/expired.vue